import { render, staticRenderFns } from "./TableDeduction.vue?vue&type=template&id=1b0843d2&scoped=true"
import script from "./TableDeduction.vue?vue&type=script&lang=js"
export * from "./TableDeduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0843d2",
  null
  
)

export default component.exports